var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { getEnvironmentRefreshStatus } from 'services/api/environment-refresh-service';
import { dateFormatHelper } from 'utils/date-format-helper';
import styles from './EnvironmentBanner.module.scss';
export function EnvironmentBanner() {
    var _this = this;
    var envName = process.env.REACT_APP_ENV_NAME;
    var _a = useState(null), refreshData = _a[0], setRefreshData = _a[1];
    useEffect(function () {
        // Only fetch if not in production
        if (!envName || envName === 'prod') {
            return;
        }
        // Fetch refresh status data
        var fetchRefreshStatus = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getEnvironmentRefreshStatus()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            setRefreshData(response.body);
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        // Silently fail - if API call fails, just don't show refresh info
                        console.error('Failed to fetch environment refresh status:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchRefreshStatus();
    }, [envName]);
    // Don't render banner for production or when environment is not set
    if (!envName || envName === 'prod') {
        return null;
    }
    // Render refresh status section
    var renderRefreshStatus = function () {
        if (!refreshData) {
            return null; // Don't show anything if data fetch failed
        }
        var _a = refreshData.environmentRefresh, dataRestore = _a.dataRestore, dataBackup = _a.dataBackup;
        // Check if refresh is currently running
        if (dataRestore.running.exists) {
            return (_jsx(Box, __assign({ className: styles.rightSection }, { children: _jsx(Typography, __assign({ className: styles.refreshText }, { children: "Refresh In Progress" })) })));
        }
        // Check if we have completed refresh data
        if (dataRestore.lastCompleted.endTime) {
            var restoreDate = new Date(dataRestore.lastCompleted.endTime);
            var formattedRestoreDate = dateFormatHelper.formatDateLongEasternWithTimezone(restoreDate);
            // Check if we should show backup date
            var showBackupDate = false;
            var formattedBackupDate = '';
            if (dataBackup.startTime) {
                var backupDate = new Date(dataBackup.startTime);
                if (backupDate < restoreDate) {
                    showBackupDate = true;
                    formattedBackupDate = dateFormatHelper.formatDateLongEasternWithTimezone(backupDate);
                }
            }
            return (_jsxs(Box, __assign({ className: styles.rightSection }, { children: [_jsxs(Typography, __assign({ className: styles.refreshText }, { children: ["Refresh from PROD completed: ", formattedRestoreDate] })), showBackupDate && (_jsxs(Typography, __assign({ className: styles.refreshText }, { children: ["Contains data up to: ", formattedBackupDate] })))] })));
        }
        return null;
    };
    return (_jsxs(Box, __assign({ className: styles.banner }, { children: [_jsxs(Box, __assign({ className: styles.centerSection }, { children: [_jsx(WarningAmberIcon, { fontSize: "large" }), _jsxs(Box, __assign({ className: styles.textContainer }, { children: [_jsx(Typography, __assign({ className: styles.text }, { children: "You are NOT on production." })), _jsxs(Typography, __assign({ className: styles.text }, { children: ["You are in the ", _jsx("strong", { children: envName.toUpperCase() }), " environment."] }))] }))] })), renderRefreshStatus()] })));
}
